import VorsorgeHomeController from './home/VorsorgeHomeController';

angular
  .module('VSPApp')
  .controller('VorsorgeHomeController', VorsorgeHomeController);
